import React, { useState } from "react";
import moment from "moment";
import {
  Form,
  Row,
  Col,
  DatePicker,
  InputNumber,
  Input,
  PageHeader,
  Breadcrumb,
  Button,
  Spin,
  message,
} from "antd";
import { taxTypeService } from "_services";

import { Link } from "react-router-dom";

function Add({ history, match }) {
  const { path } = match;
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);

  const handleFormSubmit = () => {
    setLoading(true);

    form
      .validateFields()
      .then((values) => {
        const payload = {
          ...values,
          validFrom: moment(values.validFrom).format("YYYY-MM-DD"),
          validTo: moment(values.validTo).format("YYYY-MM-DD"),
        };

        taxTypeService
          .create(payload)
          .then(() => {
            message.success("Successfully Created!", 3);
            history.push(".");
            setLoading(false);
          })
          .catch((error) => {
            message.error(`${error}`, 3);
            setLoading(false);
          });
      })
      .catch((error) => {
        setLoading(false);
        message.error(error, 3);
      });
  };
  const getActionButtons = () => {
    let buttons = [];

    buttons.push(
      <Button type="primary" onClick={handleFormSubmit}>
        Add
      </Button>
    );

    buttons.push(
      <Link to={`/`} key="1">
        <Button>Cancel</Button>
      </Link>
    );

    return buttons;
  };

  return (
    <PageHeader
      title={
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to={`/dashboard`}>Dashboard</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/tax-types`}>Tax Types</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`${path}`}>Add</Link>
          </Breadcrumb.Item>
        </Breadcrumb>
      }
      extra={getActionButtons()}
    >
      <Spin spinning={loading}>
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            validFrom: moment(),
            validTo: moment().add(1, "year"),
          }}
        >
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item
                name={["code"]}
                label="Code"
                rules={[{ message: "Need to have a Code", required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name={["name"]}
                label="Name"
                rules={[{ message: "Need to have a Name", required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name={["description"]}
                label="Description"
                rules={[
                  { message: "Need to have a Description", required: false },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item name={["rate"]} label="Rate">
                <InputNumber min={1} max={999999} />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col span={6}>
              <Form.Item
                name={["validFrom"]}
                label="Valid From"
                rules={[
                  { message: "Need to have a Valid from", required: true },
                ]}
              >
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item
                name={["validTo"]}
                label="Valid To"
                rules={[{ message: "Need to have a Valid to", required: true }]}
              >
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Spin>
    </PageHeader>
  );
}

export default Add;
